
export default function ErrorPage({ error }: { error: { msg: string, request_id: string } }) {
    return (
        <div className={"min-h-screen flex justify-center items-center flex-col opacity-40"}>
            <img alt={"empty"}
                src={"/img/faill@1.0x.png"}
                width={120}
                height={120} />
            <div className={"text-sm"}>哎呀！你遇到了一个错误</div>
            <div className={"text-sm"}>请求ID：{error.request_id || "ERR_FURRIES-0000.0000.0001"}</div>
            <div className={"text-sm"}>错误讯息：{error.msg}</div>
        </div>
    )
}
